module.exports = "/images/ford_tshirt.gif?d8fa791cad72778dc522f4a56d61fb70";